import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import SiteFooter from '../components/SiteFooter';

export default function CafesList() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    (async () => {
      const snap = await getDocs(query(collection(db,'cafes'), orderBy('cafeName')));
      setItems(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    })();
  }, []);
  return (
    <div style={{background:'#F6F4EF', minHeight:'100vh'}}>
      <div style={{maxWidth:900, margin:'0 auto', padding:'24px 16px'}}>
        <h1>Список усіх кавʼярень</h1>
        <div style={{display:'grid', gap:12}}>
          {items.map(c => (
            <div key={c.id} style={{background:'#fff', border:'1px solid #e5e7eb', borderRadius:10, padding:12}}>
              <div style={{fontWeight:800, fontSize:16}}>
                <a href={`/cafe/${encodeURIComponent(c.cafeName)}`} style={{color:'#0b5226', textDecoration:'underline'}}>
                  {c.cafeName}
                </a>
              </div>
              <div style={{color:'#6b7280'}}>{c.cafeAddress}</div>
              <div style={{marginTop:8}}>
                <a
                  href={c.lat && c.lng
                    ? `https://www.google.com/maps?q=${c.lat},${c.lng}`
                    : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${c.cafeName}, ${c.cafeAddress||''}`)}`
                  }
                  target="_blank" rel="noreferrer"
                  style={{color:'#0b5226'}}
                >
                  Показати на мапі
                </a>
              </div>
            </div>
          ))}
          {!items.length && <div>Завантаження…</div>}
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}

